import { Component, OnInit, inject } from '@angular/core';
import {DataService} from '../services/data.service';
import {Router} from '@angular/router';
import {AccessService} from '../services/access.service';
import {LocalStorageService} from '../services/local-storage.service';
import {environment} from '../../environments/environment';
import {ToastrService} from "ngx-toastr";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-login',
    imports: [FormsModule],
    styles: `
        :host {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 40px 16px;
            background-color: #f5f5f5;
        }

        .form-signin {
            width: 100%;
            max-width: 380px;
        }

        .card {
            border-radius: 0.75rem;
        }

        .card-body {
            padding: 24px;
        }

        .form-signin .form-floating:focus-within {
            z-index: 2;
        }

        .form-signin .form-floating + .form-floating {
            margin-top: -1px; /* seamless borders between floating inputs */
        }

        .form-signin input[type="text"] {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        .form-signin input[type="password"] {
            margin-bottom: 10px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    `,
    template: `
        <main class="form-signin" id="anmeldung">
            <div class="card shadow-sm">
                <div class="card-body">
                    <form data-bitwarden-watching="1" name="loginform" (ngSubmit)="login()">
                        <div class="d-flex mb-3" style="font-size: 1.2rem">
                            <div class="flex-shrink-0">
                                <img [src]="'assets/img/favicon/' + accessService.client.slug + '/android-chrome-192x192.png'" alt="Logo" class="mx-2" style="height: 66px">
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h5 class="fw-bold mb-0 p-0 bg-transparent" style="font-size: 30px;">{{ accessService.client.name }}</h5>
                                <small class="text-muted" style="font-size: 20px">Management Cockpit</small>
                            </div>
                        </div>

                        <div class="form-floating mb-2">
                            <input type="text" class="form-control" id="login_email" [(ngModel)]="email" name="email" placeholder="E-Mail">
                            <label for="login_email">E-Mail</label>
                        </div>
                        <div class="form-floating">
                            <input type="password" class="form-control" id="login_password" [(ngModel)]="password" name="password" placeholder="Passwort">
                            <label for="login_password">Passwort</label>
                        </div>

                        <button class="w-100 btn btn-lg btn-primary mt-3" type="submit">Anmelden</button>
                    </form>
                </div>
            </div>
        </main>
    `
})
export class LoginComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private router = inject(Router);
    private localStorageService = inject(LocalStorageService);
    private toastrService = inject(ToastrService);

    email: string = environment.email
    password: string = environment.password
    showLogin = false;

    ngOnInit(): void {
        const token = this.localStorageService.getItem('token');

        if (token) {
            this.accessService.token = token;
            this.dataService.request("User/get").subscribe(response => {
                if (!response.error) {
                    this.accessService.user = response.user;
                    this.router.navigate(['/dashboard']);
                } else {
                    this.showLogin = true;
                }
            });
        } else {
            this.showLogin = true;
        }
    }

    login(): void {
        this.dataService.request("User/login", {
            email: this.email,
            password: this.password
        }).subscribe(response => {
            if (response.error === false) {
                this.email = '';
                this.password = '';
                this.accessService.token = response.token;
                this.accessService.user = response.user;
                this.localStorageService.setItem('token', response.token);
                this.router.navigate(['/dashboard']);
                this.toastrService.success('Login erfolgreich');
            } else {
                this.toastrService.error(response.error);
            }
        });
    }
}
